import React, { useEffect } from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { useStore } from '../../../../stores/root';

// assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faHome, faXmarkCircle } from '@fortawesome/pro-light-svg-icons';

// services

// props
import { IEmployeeContractResourceProps } from '../../../../props/employees/contracts/contract';

// components
import { ActionButton, CommandBar, IButtonProps, ICommandBarItemProps, PrimaryButton, Stack } from '@fluentui/react';
import Text from '../../../typography/text';
import LoadingComponent from '../../../feedbacks/loading';
import Label from '../../../typography/label';
import Details from '../../../typography/details';
import GeneralService from '../../../../services/general';
import Tag from '../../../uiframeworks/tag';
import { IVesselResourceProps } from '../../../../props/vessels/vessel';

interface VesselDetailsPropertiesProps {
    vessel: IVesselResourceProps;
}

const VesselDetailsProperties: React.FC<VesselDetailsPropertiesProps> = observer((props: VesselDetailsPropertiesProps) => {
    const { banner, topbar, user } = useStore();
    const { vessel } = props;

    return <Stack tokens={{ childrenGap: 20 }}>
        <Stack tokens={{ childrenGap: 20 }} horizontal>
            <Details title={'Name'} text={vessel.name} style={{ width: '25%' }} />
            <Details title={'Registration number'} text={vessel.registrationNumber} style={{ width: '25%' }} />
            <Details title={'Subsidiary'} text={vessel.subsidiary.name} style={{ width: '25%' }} />
            <Details title={'Type / Flag'} text={vessel.type.name + " / " + vessel.flag.name} style={{ width: '25%' }} />
        </Stack>
        <Stack tokens={{ childrenGap: 20 }} horizontal>
            <Details title={'Year made'} text={vessel.yearMade} style={{ width: '25%' }} />
            <Details title={'Class'} text={vessel.class} style={{ width: '25%' }} />
            <Details title={'Construction'} text={vessel.construction} style={{ width: '25%' }} />
            <Details title={'Call sign'} text={vessel.callSign} style={{ width: '25%' }} />
        </Stack>
        <Stack className={'divider'} />
        <Stack tokens={{ childrenGap: 20 }} horizontal>
            <Details title={'LOA / Panjang keseluruhan'} text={GeneralService.getNumberWithSeparator(vessel.loa) + " m"} style={{ width: '25%' }} />
            <Details title={'LBP / Panjang antara garis gerak'} text={GeneralService.getNumberWithSeparator(vessel.lbp) + " m"} style={{ width: '25%' }} />
            <Details title={'Breadth / Lebar'} text={GeneralService.getNumberWithSeparator(vessel.breadth) + " m"} style={{ width: '25%' }} />
            <Details title={'Depth / Dalam'} text={GeneralService.getNumberWithSeparator(vessel.depth) + " m"} style={{ width: '25%' }} />
        </Stack>
        <Details title={'Maximum full load / Draft'} text={GeneralService.getNumberWithSeparator(vessel.maximumLoad) + " m"} style={{ width: '25%' }} />
        <Stack className={'divider'} />
        <Stack tokens={{ childrenGap: 20 }} horizontal>
            <Details title={'Gross tonage'} text={GeneralService.getNumberWithSeparator(vessel.grossTonage) + " kg"} style={{ width: '25%' }} />
            <Details title={'Nett tonage'} text={GeneralService.getNumberWithSeparator(vessel.nettTonage) + " kg"} style={{ width: '25%' }} />
            <Stack styles={{root: {width: '25%'}}}> </Stack>
            <Stack styles={{root: {width: '25%'}}}> </Stack>
        </Stack>
    </Stack>;
});

export default VesselDetailsProperties;
